/**
 * The catalog key each settings-text helper in `@/core/utils/rapidstor` accepts an
 * Automate override on, keyed by helper name.
 *
 * Dot form, matching `translation_keys.key` in Automate. Both sides read this one
 * module: the helpers convert to i18next's `ns:key` form at lookup time, and
 * `scripts/generate-translations.mjs` declares these keys in the payload the
 * catalog syncs from — so a runtime key and a catalog key cannot drift apart.
 *
 * Two rules hold for every entry:
 *
 * 1. **The key lives in the `rapidstor` namespace.** No base language bundles
 *    that namespace, so it exists only once Automate has sent an override. That
 *    is what lets an i18next hit be read as authored rather than as a generic
 *    default, which would displace the operator's own RapidStor setting on every
 *    site. `buildTranslationsPayload` fails the build if `base` ever gains one.
 * 2. **The key need not match the helper name.** `noAvailableUnitText` reads
 *    `noAvailableUnitsText`, and `showPricesTitleText` matches no setting name at
 *    all — its bundled fallback is corp `contact_card.showPrices.title`, which is
 *    deliberately *not* the override key: `contact_card` is a bundled namespace.
 *
 * This module is evaluated as a plain object literal by the generator (no TS
 * loader), so keep it to this single export with no imports.
 */
export const SETTINGS_TEXT_KEYS = {
    payNowButtonText: 'rapidstor.payNowButtonText',
    payLaterButtonText: 'rapidstor.payLaterButtonText',
    saveQuoteButtonText: 'rapidstor.saveQuoteButtonText',
    showPricesButtonText: 'rapidstor.showPricesButtonText',
    showPricesTitleText: 'rapidstor.showPricesTitleText',
    noAvailableUnitText: 'rapidstor.noAvailableUnitsText',
};
